import { useId } from 'react'

// FragranceOS brand mark — gradient droplet from the 2026-07-07 brand board.
// Palette: Gold #D4AF37 · Royal Purple #7B5CFF · Rose #D05297 · Midnight #0D0F1A
export function DropletLogo({ className = 'w-7 h-7' }) {
  const id = useId()
  return (
    <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={id} x1="24" y1="4" x2="36" y2="44" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#D4AF37" />
          <stop offset="0.58" stopColor="#7B5CFF" />
          <stop offset="1" stopColor="#D05297" />
        </linearGradient>
      </defs>
      <path
        d="M24 4 C24 4 8 20 8 30 a16 16 0 0 0 32 0 C40 20 24 4 24 4 Z"
        stroke={`url(#${id})`}
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M15 31 a9.5 9.5 0 0 0 7.5 7.5"
        stroke="#D05297"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  )
}

// Two-tone wordmark: "Fragrance" in gold, "OS" in the royal→rose gradient.
export function Wordmark({ className = 'text-lg' }) {
  return (
    <span className={`font-display tracking-wide ${className}`}>
      <span className="text-gold">Fragrance</span>
      <span className="bg-gradient-to-r from-royal to-rose bg-clip-text text-transparent">OS</span>
    </span>
  )
}
